import {VueSignaturePad} from "vue-signature-pad";

require('./bootstrap');

import '../plugins/vue-composition-api';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import vuetify from './vuetify';
import store from './store';

import Head, { createInertiaApp, Link, plugin } from '@inertiajs/inertia-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { InertiaProgress } from '@inertiajs/progress';
import VuePusher from 'vue-pusher';
import VueApexCharts from 'vue-apexcharts';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import VueColumnsResizableVuetify from 'vue-columns-resizable-vuetify';

Vue.use(VueCompositionAPI);
Vue.use(VueAxios, axios);
Vue.use(plugin);
Vue.use(VuePusher, {
	api_key: 'aeaf510dd880d1927df1',
	options: {
		cluster: 'eu',
		encrypted: true,
	},
});
Vue.use(VueApexCharts);
Vue.use(VueColumnsResizableVuetify);
Vue.use(VueSignaturePad);
Vue.component('apexchart', VueApexCharts);
Vue.filter('numFormat', numFormat(numeral));

Vue.prototype.$route = route;

InertiaProgress.init({
	color: '#0F8576',
});

createInertiaApp({
	title: (title) => `${title}`,
	resolve: async (name) => {
		return await import(`./Pages/${name}`);
	},
	setup({ el, App, props }) {
		new Vue({
			store,
			vuetify: vuetify,
			render: (h) => h(App, props),
			components: {
				InertiaHead: Head,
				InertiaLink: Link,
			},
			mounted() {
				const theme = localStorage.getItem('dark_theme');
				if (theme) {
					if (theme === 'true') {
						this.$vuetify.theme.dark = true;
					} else {
						this.$vuetify.theme.dark = false;
					}
				}
			},
		}).$mount(el);
	},
});
